/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/**
 * Defines the Design Language Trailer Door Widget Icon.
 *
 * ```typescript
 *    import {TrailerDoorWidgetIcon} from '@ion/dls/src/icons/';
 *
 *    <TrailerDoorWidgetIcon />
 */
export const TrailerDoorWidgetIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize - 7} height={iconSize} viewBox='0 0 24 31' fill='none'>
      <path d='M2.3665 1.30778H21.2381C21.3905 1.30776 21.5414 1.33902 21.682 1.39975C21.8226 1.46049 21.95 1.54947 22.0569 1.66152C22.1638 1.77356 22.248 1.90644 22.3047 2.05239C22.3613 2.19834 22.3891 2.35445 22.3867 2.51163V22.6737H1.19928V2.51163C1.19676 2.35282 1.22522 2.19511 1.28299 2.04787C1.34075 1.90064 1.42663 1.76689 1.53553 1.65458C1.64442 1.54226 1.7741 1.45369 1.91686 1.39411C2.05961 1.33453 2.21252 1.30517 2.3665 1.30778V1.30778Z'
        stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10'/>
      <path d='M6.50255 22.6736H1.20337V29.126H6.50255V22.6736Z'
        stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10'/>
      <path d='M22.385 22.6736H17.0858V29.3076H22.385V22.6736Z'
        stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10'/>
      <path d='M10.2389 19.1617H14.2074'
        stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10'/>
      <line x1='6.81241' y1='25.7535' x2='16.7773' y2='25.7535'
        stroke={iconColor} strokeWidth='1.5'/>
    </svg>
  );
};
